import login from '@/Login'
import tabs from '@/views/tabs/index'
import web from '@/views/web'
import regist from '@/views/Regist.vue'
import purchaseOrder from '@/views/purchaseOrder/list'
import purchaseDetail from '@/views/purchaseOrder/detail'
import purchaseDetailFocus from '@/views/purchaseOrder/detailFocus'
import supplierOrder from '@/views/supplierOrder/list'
import supplierOrderDetail from '@/views/supplierOrder/detail'
import inquiryPrice from '@/views/inquiryPrice/list'
import inquiryPriceDetail from '@/views/inquiryPrice/detail'
import goodsSumReport from '@/views/report/goodsSumReport'
import goodsStockSumReport from '@/views/report/goodsStockSumReport'
import stateMentOrder from '@/views/stateMent/list'
import stateMentDetail from '@/views/stateMent/detail'
import settleBillOrder from '@/views/settleBill/list'
import settleBillDetail from '@/views/settleBill/detail'


import stockInReport from '@/views/stockInReport/list'
import stockInReportDetail from '@/views/stockInReport/detail'
import stockOutReport from '@/views/stockOutReport/list'
import stockOutReportDetail from '@/views/stockOutReport/detail'



var routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      title: "登录", //标题
      rank:1,
    },
    component: login
  },
  {
    path: '/tabs',
    name: 'tabs',
    meta: {
      title: "费用单", //标题
      keepAlive:true,
      rank:2
    },
    component: tabs
  },
  {
    path: '/web',
    name: 'web',
    meta: {
      title: "费用单", //标题
      keepAlive:true,
      rank:2
    },
    component: web
  },
  {
    path: '/purchaseDetail',
    name: 'purchaseDetail',
    meta: {
      title: "订货单详情", //标题
      rank:3
    },
    component: purchaseDetail
  },
  {
    path: '/purchaseDetailFocus',
    name: 'purchaseDetailFocus',
    meta: {
      title: "集中订货单", //标题
      rank:3
    },
    component: purchaseDetailFocus
  },
  {
    path: '/supplierOrder',
    name: 'supplierOrder',
    meta: {
      title: "订货单申请", //标题
      keepAlive:true,
      rank:2
    },
    component: supplierOrder
  },
  {
    path: '/supplierOrderDetail',
    name: 'supplierOrderDetail',
    meta: {
      title: "订货单申请详情", //标题
      rank:3
    },
    component: supplierOrderDetail
  },
  {
    path: '/inquiryPrice',
    name: 'inquiryPrice',
    meta: {
      title: "询价单列表", //标题
      keepAlive:true,
      rank:2
    },
    component: inquiryPrice
  },
  {
    path: '/inquiryPriceDetail',
    name: 'inquiryPriceDetail',
    meta: {
      title: "询价单详情", //标题
      rank:3
    },
    component: inquiryPriceDetail
  },
  {
    path: '/goodsSumReport',
    name: 'goodsSumReport',
    meta: {
      title: "商品销售报表", //标题
      rank:2
    },
    component: goodsSumReport 
  },
  {
    path: '/goodsStockSumReport',
    name: 'goodsStockSumReport',
    meta: {
      title: "库存销售报表", //标题
      rank:2
    },
    component: goodsStockSumReport 
  },
  {
    path: '/stateMentOrder',
    name: 'stateMentOrder',
    meta: {
      title: "对账单列表", //标题
      keepAlive:true,
      rank:2
    },
    component: stateMentOrder
  },
  {
    path: '/stateMentDetail',
    name: 'stateMentDetail',
    meta: {
      title: "对账单详情", //标题
      rank:3
    },
    component:stateMentDetail
  },  
  {
    path: '/settleBillOrder',
    name: 'settleBillOrder',
    meta: {
      title: "结算单列表", //标题
      keepAlive:true,
      rank:2
    },
    component: settleBillOrder
  },
  {
    path: '/settleBillDetail',
    name: 'settleBillDetail',
    meta: {
      title: "结算单详情", //标题
      rank:3
    },
    component:settleBillDetail
  },  
  {
    path: '/stockInReport',
    name: 'stockInReport',
    meta: {
      title: "客户入库单列表", //标题
      keepAlive:true,
      rank:2
    },
    component: stockInReport
  },
  {
    path: '/stockInReportDetail',
    name: 'stockInReportDetail',
    meta: {
      title: "客户入库单详情", //标题
      rank:3
    },
    component: stockInReportDetail
  },
  {
    path: '/stockOutReport',
    name: 'stockOutReport',
    meta: {
      title: "客户退货单列表", //标题
      keepAlive:true,
      rank:2
    },
    component: stockOutReport
  },
  {
    path: '/stockOutReportDetail',
    name: 'stockOutReportDetail',
    meta: {
      title: "客户退货单详情", //标题
      rank:3
    },
    component: stockOutReportDetail
  },
]
export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js